import NotificationCard from '@shared/components/notification/NotificationCard';
import INotificationModel from '@shared/models/users/NotificationModel';
import { useTranslation } from 'react-i18next';
import PageBannerCard from '../core/card/PageBannerCard';

interface NotificationListingProps {
    notifications: INotificationModel[];
}

const NotificationListing: React.FC<NotificationListingProps> = ({ notifications }) => {
    const { t } = useTranslation();
    if (!notifications) return null;
    if (notifications.length < 1) return <PageBannerCard title={t('common:notifications.empty')} />;
    return (
        <div>
            {notifications.map((notification) => (
                <NotificationCard key={notification.id} {...notification} />
            ))}
        </div>
    );
};

export default NotificationListing;
